import { ComponentDto } from "@intelligems/ig-types/dtos/components";
import { VariationDto } from "@intelligems/ig-types/dtos/variations";

// Flatten the components across an experience's variations, the way
// `getOnsiteEditsFromExperienceDto` flattens edits. Holds every `ComponentDto`
// type (onsiteUpsell today, bundle soon); type-specific handling narrows later.
export const getComponentsFromExperienceDto = (
  variations: VariationDto[]
): ComponentDto[] => {
  const components: ComponentDto[] = [];
  for (const variation of variations) {
    components.push(...(variation.components ?? []));
  }
  return components;
};
